// faq-group-toggle

const faq = () => {
  setTimeout(() => {
    document.addEventListener('click', (event) => {
      const { target } = event;

      if (target && target.matches('.faq-group-toggle')) {
        event.preventDefault();
        target.parentNode.classList.toggle('open');
      }
    });
  }, 100);


  const FaqFilterToggle = () => {
    const button = document.querySelector('.toggle-faq-groups');
    const widgetContainer = document.querySelector('.shop-filter-widgets');

    if (button) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        widgetContainer.classList.toggle('open');
      });
    }
  };


  const FaqMcb = () => {
    const links = Array.from(document.querySelectorAll('.faq-link'));
    const contentContainer = document.getElementById('faq-content');
    const sidebar = document.querySelector('.shop-filter-widgets');

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const currentActive = document.querySelector('.faq-link.active');
        if (currentActive) {
          currentActive.classList.remove('active');
        }
        link.classList.add('active');
        sidebar.classList.remove('open');

        const content = link.parentNode.querySelector('.the-stored-content');
        contentContainer.innerHTML = content.innerHTML;
      });
    });

    links[0].click();

    if (window.innerWidth <= 850) {
      const button = document.querySelector('.toggle-faq-groups');
      if (button) {
        button.click();
      }
    }
  };

  FaqFilterToggle();
  if (document.body.classList.contains('page-id-461')) {
    FaqMcb();
  }
};
faq();
